import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";
import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private auth: AuthService, private injector: Injector, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.auth.getAccessToken();
    let authReq = req;

    if (accessToken) {
      authReq = req.clone({
        setHeaders:{
            'Authorization': `Bearer ${accessToken}`,
            //'Content-Type': 'application/json'
        }
        //headers: req.headers.set('Authorization', `Bearer ${accessToken}`)
      });
    }
    else{
        authReq = req.clone({
            setHeaders:{
                'Content-Type': 'application/json'
            }
          });
    }

    return next.handle(authReq).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(req, next);
        }
        return throwError(error);
      })
    );
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //req.headers.set('Content-Type','application/json');
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.auth.refreshToken().pipe(
        switchMap((tokens: any) => {
          this.isRefreshing = false;
          this.auth.saveTokens(tokens.accessToken, tokens.refreshToken);
          this.refreshTokenSubject.next(tokens.accessToken);
          return next.handle(req.clone({
            setHeaders:{
                'Authorization': `Bearer ${tokens.accessToken}`,
                'Content-Type': 'application/json'
            }
            //headers: req.headers.set('Authorization', `Bearer ${tokens.accessToken}`)
          }));
        }),
        catchError(err => {
          this.isRefreshing = false;
          if(err.url.includes('api/user/refreshtoken')){
            this.auth.logout();
            this.router.navigate(['/login']);
          }
          return throwError(err);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap((token) =>
          next.handle(req.clone({
            setHeaders:{
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
            //headers: req.headers.set('Authorization', `Bearer ${token}`)
          }))
        )
      );
    }
  }
}